export default "__VITE_ASSET__4e206b56__"